import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "page-hero" }
const _hoisted_2 = { class: "flex flex-col gap-3 md:flex-row md:items-end md:justify-between" }
const _hoisted_3 = { class: "min-w-0 text-left" }
const _hoisted_4 = { class: "text-xs font-bold uppercase text-blue-100" }
const _hoisted_5 = { class: "mt-1.5 text-lg font-black leading-tight md:text-xl" }
const _hoisted_6 = {
  key: 0,
  class: "mt-2 max-w-2xl text-xs font-semibold leading-5 text-blue-50"
}
const _hoisted_7 = {
  key: 0,
  class: "shrink-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString($props.eyebrow), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString($props.title), 1),
        ($props.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($props.description), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.$slots.actions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "actions")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}